import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["start", "timeout"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
export var Timer = /*#__PURE__*/function (_React$Component) {
  _inherits(Timer, _React$Component);

  var _super = _createSuper(Timer);

  function Timer(props) {
    var _this;

    _classCallCheck(this, Timer);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "timer", void 0);

    _defineProperty(_assertThisInitialized(_this), "startTimer", function () {
      _this.setState({
        isEnabled: true
      });

      _this.timer = window.setInterval(function () {
        var _this$props = _this.props,
            start = _this$props.start,
            timeout = _this$props.timeout,
            onTimeout = _this$props.onTimeout;

        if (Math.round(start.getTime() / 1000) + timeout <= Math.round(new Date().getTime() / 1000)) {
          _this.stopTimer();

          onTimeout();
          return;
        }

        _this.forceUpdate();
      }, 500);
    });

    _defineProperty(_assertThisInitialized(_this), "stopTimer", function () {
      _this.setState({
        isEnabled: false
      });

      window.clearInterval(_this.timer);
    });

    _this.state = {
      isEnabled: false
    };
    return _this;
  }

  _createClass(Timer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.startTimer();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.stopTimer();
    }
  }, {
    key: "render",
    value: function render() {
      var isEnabled = this.state.isEnabled;

      if (!isEnabled) {
        return null;
      }

      var _this$props2 = this.props,
          start = _this$props2.start,
          timeout = _this$props2.timeout,
          spanProps = _objectWithoutProperties(_this$props2, _excluded);

      var remainingTime = Math.round((start.getTime() + timeout * 1000 - new Date().getTime()) / 1000);
      return /*#__PURE__*/React.createElement("span", spanProps, remainingTime);
    }
  }]);

  return Timer;
}(React.Component);